import { render, staticRenderFns } from "./BulkIssueEligibleTable.vue?vue&type=template&id=70a730f9&scoped=true"
import script from "./BulkIssueEligibleTable.vue?vue&type=script&lang=js"
export * from "./BulkIssueEligibleTable.vue?vue&type=script&lang=js"
import style0 from "./BulkIssueEligibleTable.vue?vue&type=style&index=0&id=70a730f9&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70a730f9",
  null
  
)

export default component.exports